import React from 'react'
import styled from '@emotion/styled'
import { LoadingImage } from '../../generic/Basics'
import { grayLight20, fontWeightBold, fontSizeMedium, fontSize3XSmall, fontSize2XSmall, fontSizeXSmall } from '../../../constants/principles'
import Error from '../../generic/Error'
import FeaturesAndEquipment from '../FeaturesAndEquipment'

export default ({ displayImages, images, isDesktop, vin, year = {}, make = {}, model = {}, engine, transmission, drivetrain, color, options, genericOptions, setShowModal, isError, trim, vinResults, offer, prospect }) => (
  <>
    <LoadingImage displayImages={displayImages} images={images} spinnerSize={50} imgMarginTop={isDesktop ? -35 : -15} imgWidth={isDesktop ? 480 : 210} width={isDesktop ? 480 : 210} height={isDesktop ? 360 : 136} marginBottom={isDesktop ? -30 : 0} />
    <TextWithSubheaderDiv fontSize={fontSizeMedium} fontWeight={fontWeightBold}>
      {year.displayName} {make.displayName} {model.displayName} {trim && trim.displayName}
    </TextWithSubheaderDiv>
    {images && displayImages && <TextWithSubheaderDiv fontSize={fontSize3XSmall}>Image may not exactly match your vehicle</TextWithSubheaderDiv>}
    {vin && (
      <TextDiv fontSize={fontSize2XSmall} fontColor={grayLight20}>
        VIN: {vin}
      </TextDiv>
    )}{' '}
    {vin && !!trim && (
      <TextDiv fontSize={fontSizeXSmall} fontWeight={fontWeightBold}>
        Your VIN confirmed key details about your vehicle, but we still need some information.
      </TextDiv>
    )}
    {isError && <Error isError={isError} id={'renew-error'} text={'This offer has already been resubmitted.'} />}
    {<FeaturesAndEquipment _engine={engine} _transmission={transmission} _drivetrain={drivetrain} _color={color} _options={options} _genericOptions={genericOptions} setShowModal={setShowModal} vinResults={vinResults} offer={offer} prospect={prospect} />}
  </>
)

const TextDiv = styled.div`
  font-size: ${p => p.fontSize};
  font-weight: ${p => p.fontWeight};
  color: ${p => p.fontColor};
  padding-bottom: 16px;
`

const TextWithSubheaderDiv = styled(TextDiv)`
  padding-bottom: 0;
  width: 100%;
  text-align: center;
  background-color: white;
`
